import _ from 'lodash';
import { Map } from 'immutable';

import Station from '../records/Station';
import StationService from '../services/StationService';

let stations = new Map();

let searches = new Map();

const StationStore = {

    async search(text, type = null, filterByBrand = false) {
        const key = `${text}/${type}`;
        if (searches.has(key)) {
            return searches.get(key);
        }

        try {
            const response = await StationService.search(text, type, filterByBrand);

            const result = response.map(station => {
                if (stations.has(station.nlc)) {
                    return stations.get(station.nlc);
                }
                stations = stations.set(station.nlc, station);
                return station;
            });

            searches = searches.set(key, result);

            return result;
        } catch (error) {
            console.error('StationService.search failed:', error);
            throw error; // preserve rejection for callers
        }
    },

    get(id) {
        return new Promise((resolve) => {
            if (!id) {
                resolve(new Station());
                return;
            }

            if (stations.has(id)) {
                resolve(stations.get(id));
                return;
            }

            //Do a get for numeric ids (nlc)
            if (_.isNumber(id) || /\d+/.exec(String(id))) {
                resolve(
                    StationService.get(id)
                        .then(station => {
                            stations = stations.set(id, station);
                            return station;
                        }).catch((e) => {
                            console.error(e);
                            return new Station();
                        })
                );
            } else { //And a search for anything else (crs)
                const upperCaseId = id.toUpperCase();
                if (stations.has(upperCaseId)) {
                    resolve(stations.get(upperCaseId));
                    return;
                }
                resolve(
                    this.search(upperCaseId).then((results) => {
                        let found = results.find((station) => station.crs === upperCaseId);
                        if (found) {
                            stations = stations.set(upperCaseId, found);
                            return found;
                        }
                        return new Station();
                    }).catch((e) => {
                        console.error(e);
                        return new Station();
                    })
                );
            }
        });

    }
};


export default StationStore;
